import React from 'react';
import { Heading, Slide } from 'spectacle-ppa';
import YouTube from 'components/youTube';

function videoSlide ({
    id,
    notes,
    heading,
    youTubeId,
    lowRes,
    bgColor,
    slideClass
  }) {
  const slideContentClass = slideClass ? ' slide-' + slideClass : '';
  const booleanLowRes = lowRes === 'true';
  return (
    <Slide
        id={id}
        key={id}
        bgColor={bgColor ? bgColor : 'black'}
        notes={notes}>
      <div className={'slide-content' + slideContentClass}>
        <div className="video-slide">
          { heading ?
            <Heading size={3} textColor="primary" textFont="primary">
              {heading}
            </Heading>
            : null
          }
          <YouTube
              youTubeId={youTubeId}
              lowRes={booleanLowRes}
              presentation />
        </div>
      </div>
    </Slide>
  );
}

export default videoSlide;



// WEBPACK FOOTER //
// ./programs/epsIntermediates/baseSlides/videoSlide.js